import { useMiddlewareRoutes } from "react-router-middleware-plus";
import { useSelector } from "react-redux";
import { useLocation, Navigate } from "react-router-dom";
import Dashboard from "pages/Dashboard/Dashboard";

import { parseToken, toastTips } from "utils/tools";
import Authorization from "pages/Authorization/Authorization";
import Welcome from "pages/Welcome";
import SuggestionReply from "pages/SuggestionReply";

export default function Router() {
  const CheckAuthorise = ({ children }) => {
    // only admin user can see the navbar page
    let userInfo = useSelector((state) => state.user);
    console.log({ pathUserInfo: userInfo });

    if (!!userInfo && userInfo.role == "admin") {
      return children;
    } else {
      toastTips("Only admin users have access.", "error");
      return <Navigate to="/welcome" replace />;
    }
  };

  const routes = [
    {
      path: "/",
      element: <Dashboard />,
      children: [
        { path: "/", element: <Welcome /> },
        { path: "/welcome", element: <Welcome /> },
        { path: "/authorization", middleware: [CheckAuthorise], element: <Authorization /> },
      ],
    },
    {
      path: "/sidebar",
      element: <SuggestionReply />,
    },
  ];
  return useMiddlewareRoutes(routes);
}
